import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';

@Injectable({
  providedIn: 'root',
})
export class AdminEdi834Service {
  constructor(private restangular: ApiClient) {}

  convertEdi834ToJson(edi834: string): Promise<any> {
    return this.restangular.one('v4').one('admin').one('edi834').one('to-json').customPOST({ edi834 }).toPromise();
  }

  convertJsonToEdi834(json: unknown): Promise<any> {
    return this.restangular.one('v4').one('admin').one('edi834').one('to-834').customPOST({ json }).toPromise();
  }
}
